import { render, staticRenderFns } from "./MenuTop.vue?vue&type=template&id=0cc508f2&scoped=true&"
import script from "./MenuTop.vue?vue&type=script&lang=js&"
export * from "./MenuTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cc508f2",
  null
  
)

export default component.exports